import { Component, HostBinding } from '@angular/core';

@Component({
  selector: 'nurseapp-footer',
  templateUrl: './nursefooter.component.html',
  styleUrls: ['./nursefooter.component.scss']
})

export class NurseFooterComponent {
  //Variables
  currentDate: Date = new Date();
}
